import { Navigate, useParams, useRoutes } from "react-router-dom";

import ArticleEditPage from "./article/edit";
import ArticleListPage from "./article/list";
import DestinationPage from "./destination";
import FeedPage from "./feed";
import FilterPage from "./filter";
import ListPage from "./list";
import UsagePage from "./usage";
import ViewPage from "./view";

export default () =>
  useRoutes([
    { path: "/:instanceId/feed/:feedId", element: <WithParameters component={FeedPage}/> },
    { path: "/:instanceId/feed", element: <WithParameters component={FeedPage}/> },
    { path: "/:instanceId/filter/:filterId", element: <WithParameters component={FilterPage}/> },
    { path: "/:instanceId/filter", element: <WithParameters component={FilterPage}/> },
    { path: "/:instanceId/destination/:destinationId", element: <WithParameters component={DestinationPage}/> },
    { path: "/:instanceId/destination", element: <WithParameters component={DestinationPage}/> },
    { path: "/:instanceId/usage/:ymd", element: <WithParameters component={UsagePage}/> },
    { path: "/:instanceId/usage", element: <WithParameters component={UsagePage}/> },
    { path: "/:instanceId/article/:slug", element: <WithParameters component={ArticleEditPage}/> },
    { path: "/:instanceId/article", element: <WithParameters component={ArticleListPage}/> },
    { path: "/:instanceId", element: <WithParameters component={ViewPage}/> },
    { path: "/", element: <WithParameters component={ListPage}/> },
    { path: "/*", element: <Navigate to="/not-found"/> },
  ]);

function WithParameters({ component: Comp }) {
  const parameters = useParams();
  return <Comp {...parameters} />;
}
